import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { NewTicketComponent } from './components/new-ticket/new-ticket.component';
import { AuthGuard } from './guards/auth.guard';
import { OpenTicketsComponent } from './components/open-tickets/open-tickets.component';
import { ZonasComponent } from './components/zonas/zonas.component';
import { RepuestosComponent } from './components/repuestos/repuestos.component';
import { TecnicosComponent } from './components/tecnicos/tecnicos.component';
import { TecnicoComponent } from './components/tecnico/tecnico.component';
import { TicketComponent } from './components/ticket/ticket.component';
import { NuevoTecnicoComponent } from './components/nuevo-tecnico/nuevo-tecnico.component';
import { AdminsComponent } from './components/admins/admins.component';
import { CalificarConsultaComponent } from './components/calificar-consulta/calificar-consulta.component';
import { RankingTecnicosComponent } from './components/ranking-tecnicos/ranking-tecnicos.component';
import { ListadoRepuestosComponent } from './components/listado-repuestos/listado-repuestos.component';
import { RankingTecnicoParticularComponent } from './components/ranking-tecnico-particular/ranking-tecnico-particular.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ListadoFallasComponent } from './components/listado-fallas/listado-fallas.component';
import { TecnicosModificacioinesComponent } from './components/tecnicos-modificacioines/tecnicos-modificacioines.component';
import { ConfigComponent } from './components/config/config.component';
import { MyTicketsComponent } from './components/my-tickets/my-tickets.component';
import { WhatsappMessagesComponent } from './components/whatsapp-messages/whatsapp-messages.component';


const routes: Routes = [
  { path: "", component: NewTicketComponent},
  { path: "terminos", component: NewTicketComponent},
  { path: "openTickets", component: OpenTicketsComponent, canActivate: [AuthGuard]},
  { path: "calificar", component: CalificarConsultaComponent },
  { path: "resetPassword", component: ResetPasswordComponent },
  { path: "ticket/:id", component: TicketComponent, canActivate: [AuthGuard]},
  { path: "standByTickets", component: OpenTicketsComponent, canActivate: [AuthGuard]},
  { path: "closedTickets", component: OpenTicketsComponent, canActivate: [AuthGuard]},
  { path: "zonas", component: ZonasComponent, canActivate: [AuthGuard]},
  { path: "admins", component: AdminsComponent, canActivate: [AuthGuard]},
  { path: "repuestos", component: RepuestosComponent, canActivate: [AuthGuard]},
  { path: "listado-repuestos", component: ListadoRepuestosComponent, canActivate: [AuthGuard]},
  { path: "listado-fallas", component: ListadoFallasComponent, canActivate: [AuthGuard]},
  { path: "tecnicos", component: TecnicosComponent, canActivate: [AuthGuard]},
  { path: "tecnicosActualizaciones", component: TecnicosModificacioinesComponent, canActivate: [AuthGuard]},
  { path: "tecnicos/ranking", component: RankingTecnicosComponent, canActivate: [AuthGuard]},
  { path: "tecnicos/ranking/:id", component: RankingTecnicoParticularComponent, canActivate: [AuthGuard]},
  { path: "tecnicos/tecnico/:id", component: TecnicoComponent, canActivate: [AuthGuard]},
  { path: "tecnicos/tecnicoNuevo", component: NuevoTecnicoComponent, canActivate: [AuthGuard]},
  { path: "config", component: ConfigComponent,canActivate: [AuthGuard]},
  { path: "whatsapp", component: WhatsappMessagesComponent,canActivate: [AuthGuard]},
  { path: "login", component: LoginComponent},
  

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
